import React from "react";
import CampaignList from "../components/CampaignList";

function CampaignPage() {
  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:flex md:flex-row">
        <CampaignList />
      </div>
    </div>
  );
}

export default CampaignPage;
